import { Component, OnDestroy, OnInit } from '@angular/core';
import { ListFilterModel } from '../../../../core/models/table/list-filter.model';
import { TableActionsModel } from '../../../../core/models/table/table-action.model';
import { BaseListWithEntityPhotosComponent } from '../../base-list-with-entity-photos/base-list-with-entity-photos.component';

@Component({
  selector: 'app-list-layout-extendable',
  templateUrl: './list-layout-extendable.component.html',
  styleUrls: ['./list-layout-extendable.component.scss']
})
export abstract class ListLayoutExtendableComponent extends BaseListWithEntityPhotosComponent {

  abstract rowActionSelected(rowAction: TableActionsModel): void;

  abstract buttonActionSelected( buttonAction: any) : void;

  abstract filterSelected(filterSelected: ListFilterModel) : void;

  paginationUpdated(service: any, selectedPage: any ){
    service.startIndex = selectedPage;
  }
}
